import React from 'react';
import './Footer.css';
import { 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaFacebook, 
  FaInstagram, 
  FaLinkedin,
  FaWhatsapp,
  FaArrowUp
} from 'react-icons/fa';

const Footer = ({ onShowLegal }) => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-bg">
        <div className="footer-shape"></div>
      </div>

      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section footer-about">
            <div className="footer-logo">
              <div className="footer-logo-icon">
                <span>P</span>
                <div className="logo-drop"></div>
              </div>
              <div className="footer-logo-text">
                <h3>PlumbThe2nd</h3>
                <span>Expert Plomberie</span>
              </div>
            </div>
            <p className="footer-tagline">
              Votre plombier de confiance depuis plus de 20 ans. 
              Services professionnels, garantie décennale et interventions rapides.
            </p>
            <div className="footer-certifications">
              <span className="cert-badge">SIRET Vérifié</span>
              <span className="cert-badge">Garantie Décennale</span>
              <span className="cert-badge">RC Pro</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Liens Rapides</h4>
            <ul className="footer-links">
              <li>
                <button onClick={() => scrollToSection('accueil')}>Accueil</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('a-propos')}>À Propos</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')}>Services</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('realisations')}>Réalisations</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('avis')}>Avis Clients</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')}>Contact</button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4>Nos Services</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('services')}>Dépannage d'urgence</button></li>
              <li><button onClick={() => scrollToSection('services')}>Détection de fuites</button></li>
              <li><button onClick={() => scrollToSection('services')}>Installation sanitaire</button></li>
              <li><button onClick={() => scrollToSection('services')}>WC & Évacuations</button></li>
              <li><button onClick={() => scrollToSection('services')}>Chauffe-eau</button></li>
              <li><button onClick={() => scrollToSection('services')}>Rénovation</button></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Contact</h4>
            <ul className="footer-contact">
              <li>
                <FaPhone className="contact-icon" />
                <a href={`tel:+${process.env.REACT_APP_WHATSAPP_NUMBER || '33123456789'}`}>
                  {process.env.REACT_APP_PHONE || '01 23 45 67 89'}
                </a>
              </li>
              <li>
                <FaEnvelope className="contact-icon" />
                <a href={`mailto:${process.env.REACT_APP_EMAIL || 'contact@plumbthe2nd.fr'}`}>
                  {process.env.REACT_APP_EMAIL || 'contact@plumbthe2nd.fr'}
                </a>
              </li>
              <li>
                <FaMapMarkerAlt className="contact-icon" />
                <span>Île-de-France</span>
              </li>
              <li>
                <FaWhatsapp className="contact-icon" />
                <a 
                  href={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER || '33123456789'}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Message WhatsApp
                </a>
              </li>
            </ul>

            {/* Social Media */}
            <div className="footer-social">
              <h5>Suivez-nous</h5>
              <div className="social-links">
                <a 
                  href="https://facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label="Facebook"
                  className="social-link facebook"
                >
                  <FaFacebook />
                </a>
                <a 
                  href="https://instagram.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label="Instagram"
                  className="social-link instagram"
                >
                  <FaInstagram />
                </a>
                <a 
                  href="https://linkedin.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label="LinkedIn"
                  className="social-link linkedin"
                >
                  <FaLinkedin />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              &copy; {currentYear} PlumbThe2nd - Expert Plomberie. Tous droits réservés.
            </p>
            <div className="footer-legal">
              <button onClick={onShowLegal}>Mentions Légales</button>
              <span className="separator">|</span>
              <button onClick={onShowLegal}>Politique de Confidentialité</button>
              <span className="separator">|</span>
              <button onClick={onShowLegal}>CGV</button>
            </div>
            <p className="footer-credit">
              Site créé avec passion pour servir nos clients
            </p>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button 
        className="scroll-to-top" 
        onClick={scrollToTop}
        aria-label="Retour en haut"
      >
        <FaArrowUp />
      </button>
    </footer>
  );
};

export default Footer;
